import { render, staticRenderFns } from "./Booth.vue?vue&type=template&id=149d10f7"
import script from "./Booth.vue?vue&type=script&lang=ts"
export * from "./Booth.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports